import { render, staticRenderFns } from "./RisksForm.vue?vue&type=template&id=7c0f3d25&"
import script from "./RisksForm.vue?vue&type=script&lang=js&"
export * from "./RisksForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports